import React from 'react';
import PropTypes from 'prop-types';
import Slide from '@material-ui/core/Slide';
import Grow from '@material-ui/core/Grow';

import classes from './styles.module.css';
import { BLUE_700, RED_700, GREEN_700 } from '../../../resources/colors';

export default class LineLoader extends React.PureComponent {

    state = {
        in: true,
        colorIndex: 0,
    };

    slideOut = () => this.setState(prevState => ({
        in: false,
        colorIndex: (prevState.colorIndex + 1) % this.props.colors.length,
    }));

    slideIn = () => this.setState({
        in: true,
    });

    _getBackgroundColor = () => this.props.colors[((this.state.colorIndex - 1) % this.props.colors.length + this.props.colors.length) % this.props.colors.length];

    render = () => <Grow in={this.props.visible} timeout={{ enter: 1000, exit: 500 }} unmountOnExit><div className={classes.container} style={{ ...this.props.style, backgroundColor: this._getBackgroundColor(), }}>
        <Slide in={this.state.in} direction='right' timeout={{ enter: 850, exit: 0 }} onEntered={this.slideOut} onExited={this.slideIn}>
            <div className={classes.line} style={{ backgroundColor: this.props.colors[this.state.colorIndex] }} />
        </Slide>
    </div></Grow>;

}

LineLoader.propTypes = {
    visible: PropTypes.bool.isRequired,
    colors: PropTypes.array,
};

LineLoader.defaultProps = {
    visible: false,
    colors: [BLUE_700, RED_700, GREEN_700],
};